import { apiClient } from './client';

export interface MusicTrack {
  id: string;
  title: string;
  artist: string;
  mediaFileId: string;
  coverUrl: string | null;
  durationSec: number;
  usageCount: number;
  audioUrl: string;
  createdAt: string;
}

export const musicApi = {
  async list(opts: { sort?: 'popular' | 'recent'; q?: string; limit?: number; offset?: number } = {}) {
    const res = await apiClient.get('/api/music', { params: opts });
    return res.data as { items: MusicTrack[]; total: number; limit: number; offset: number };
  },

  async get(id: string): Promise<MusicTrack> {
    const res = await apiClient.get(`/api/music/${id}`);
    return res.data;
  },

  // Admin
  async create(body: {
    title: string;
    artist: string;
    mediaFileId: string;
    coverUrl?: string | null;
    durationSec: number;
  }): Promise<MusicTrack> {
    const res = await apiClient.post('/api/music', body);
    return res.data;
  },

  async remove(id: string): Promise<void> {
    await apiClient.delete(`/api/music/${id}`);
  },

  async storiesForTrack(id: string, cursor?: string) {
    const r = await apiClient.get(`/api/music/${id}/stories`, { params: { cursor } });
    return r.data as {
      track: MusicTrack;
      items: Array<{
        id: string;
        author: { id: string; username: string; displayName: string; avatarUrl: string | null };
        mediaFileId: string;
        thumbnailUrl: string;
        mediaUrl: string;
        mimeType: string;
        contentRating: string;
        caption: string | null;
        likeCount: number;
        viewCount: number;
        isLiked: boolean;
        createdAt: string;
      }>;
      nextCursor: string | null;
    };
  },
};
